import React from "react";
import Typography from "@material-ui/core/Typography";

import DeliveryPolicy from "./delivery-policy.pdf";
import Guaranties from "./guaranties.pdf";
import PaymentPolicy from "./payment-policy.pdf";
import PrivacyPolicy from "./privacy-policy.pdf";
import { PublicOffer } from './utils/files.js';
import RefundPolicy from "./refund-policy.pdf";
import TechSpecifications from "./tech-specifications.pdf";

import Visa from "./visaverified.png";
import MC from "./mcsecurecode.png";
import Mir from "./miraccept.png";

class Footer extends React.Component {
    render() {
        const { username, partner } = this.props;
        const paymentGateway = this.props.order
            ? this.props.order.paymentGateway
            : null;

        const menuClassNames = ["menu"];

        if (!this.props.order) {
            menuClassNames.push("menu-no-order");
        }

        return (
            <React.Fragment>
                <Typography paragraph />
                <div className={menuClassNames.join(" ")}>
                    <div className="menu-list">
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/payment-policy.pdf`
                                    : PaymentPolicy
                            }
                        >
                            Порядок&nbsp;оплаты
                        </a>
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/tech-specifications.pdf`
                                    : TechSpecifications
                            }
                        >
                            Технические&nbsp;условия
                        </a>
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/guaranties.pdf`
                                    : Guaranties
                            }
                        >
                            Гарантии
                        </a>
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/delivery-policy.pdf`
                                    : DeliveryPolicy
                            }
                        >
                            Доставка
                        </a>
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/refund-policy.pdf`
                                    : RefundPolicy
                            }
                        >
                            Возврат
                        </a>
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/privacy-policy.pdf`
                                    : PrivacyPolicy
                            }
                        >
                            Конфиденциальность
                        </a>
                        <a
                            className="menu-link"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={
                                username
                                    ? `https://storage.yandexcloud.net/steklo24-landing/${username}/public-offer.pdf`
                                    : PublicOffer
                            }
                        >
                            Договор&nbsp;оферты
                        </a>
                    </div>
                </div>

                <div className="pay-info">
                    {paymentGateway === "avangard" ? (
                        <Typography
                            style={{
                                maxWidth: 1117,
                                margin: "0 auto",
                                textAlign: "center",
                                fontSize: 12,
                                lineHeight: 1.5,
                            }}
                        >
                            При оплате заказа банковской картой ввод реквизитов
                            карты происходит в&nbsp;системе электронных платежей
                            ПАО АКБ &laquo;Авангард&raquo;, который прошел
                            сертификацию в&nbsp;платежных системах Visa
                            и&nbsp;MasterCard. Представленные Вами данные
                            полностью защищены и&nbsp;никто, включая наш
                            интернет-магазин, не&nbsp;может их&nbsp;получить.
                        </Typography>
                    ) : (
                        <React.Fragment>
                            <Typography
                                style={{
                                    maxWidth: 1117,
                                    margin: "0 auto",
                                    textAlign: "center",
                                    fontSize: 12,
                                    lineHeight: 1.5,
                                }}
                            >
                                Для оплаты (ввода реквизитов Вашей карты)
                                Вы&nbsp;будете перенаправлены на&nbsp;платежный
                                шлюз ПАО СБЕРБАНК. Соединение с&nbsp;платежным
                                шлюзом и&nbsp;передача информации осуществляется
                                в&nbsp;защищенном режиме с&nbsp;использованием
                                протокола шифрования SSL. В&nbsp;случае если Ваш
                                банк поддерживает технологию безопасного
                                проведения интернет-платежей Verified
                                By&nbsp;Visa, MasterCard SecureCode, MIR Accept,
                                J-Secure для проведения платежа также может
                                потребоваться ввод специального пароля.
                            </Typography>
                            <Typography
                                style={{
                                    maxWidth: 1117,
                                    margin: "0 auto",
                                    textAlign: "center",
                                    fontSize: 12,
                                    lineHeight: 1.5,
                                }}
                            >
                                Настоящий сайт поддерживает 256-битное
                                шифрование. Конфиденциальность сообщаемой
                                персональной информации обеспечивается ПАО
                                СБЕРБАНК. Введенная информация не&nbsp;будет
                                предоставлена третьим лицам за&nbsp;исключением
                                случаев, предусмотренных законодательством РФ.
                                Проведение платежей по&nbsp;банковским картам
                                осуществляется в&nbsp;строгом соответствии
                                с&nbsp;требованиями платежных систем МИР, Visa
                                Int., MasterCard Europe Sprl, JCB.
                            </Typography>
                        </React.Fragment>
                    )}
                </div>
                <div className="footer-container">
                    <div className="footer-payments">
                        <img
                            src={Visa}
                            alt="Verified by Visa"
                            title="Verified by Visa"
                            height={30}
                        />
                        <img
                            src={MC}
                            alt="Mastercard SecureCode"
                            title="Mastercard SecureCode"
                            height={30}
                        />
                        <img
                            src={Mir}
                            alt="MIRAccept"
                            title="MIRAccept"
                            height={30}
                        />
                    </div>
                    <div>
                        <Typography className="footer-copyright-text">
                            {partner && partner.ip_info
                                ? partner.ip_info
                                : "ИП Ермолаев Николай Иванович, ОГРНИП 318583500024541 от 28.04.2018, ИНН 583805739250."}{" "}
                            *
                        </Typography>
                        <Typography className="footer-copyright-text">
                            Служба поддержки клиентов +7 495 649-61-45,
                            steklo-24@yandex.ru
                        </Typography>
                        <Typography className="footer-copyright-text">
                            &copy;&nbsp;СТЕКЛО24.МОСКВА Все права защищены
                            2013&nbsp;&mdash; {new Date().getFullYear()}гг.
                        </Typography>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.jsx